var map = {
	"./mine/mine.module": [
		"./src/app/mine/mine.module.ts"
	],
	"./shop-car/shop-car.module": [
		"./src/app/shop-car/shop-car.module.ts"
	],
	"./shopList/shopList.module": [
		"./src/app/shopList/shopList.module.ts"
	],
	"./tab-index/tab-index.module": [
		"./src/app/tab-index/tab-index.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;